var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ipc6mias7b",
    x1: "46.359%",
    x2: "768.084%",
    y1: "60.824%",
    y2: "-1631.266%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mnyh3aekkc",
    x1: "102.335%",
    x2: "669.414%",
    y1: "-74.607%",
    y2: "-1432.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5p1lq97u1d",
    x1: "129.502%",
    x2: "646.868%",
    y1: "-134.724%",
    y2: "-1373.553%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "utfejok9me",
    x1: "150.685%",
    x2: "615.397%",
    y1: "-186.041%",
    y2: "-1298.785%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "krj7kdqc5f",
    x1: "82.079%",
    x2: "798.07%",
    y1: "-20.871%",
    y2: "-1750.368%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x3qnbtuiag",
    x1: "116.023%",
    x2: "747.8%",
    y1: "-105.584%",
    y2: "-1618.374%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dx8booluuh",
    x1: "114.711%",
    x2: "745.704%",
    y1: "-104.698%",
    y2: "-1613.945%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "csg60kroei",
    x1: "149.15%",
    x2: "717.187%",
    y1: "-181.24%",
    y2: "-1541.415%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j53wtu0exj",
    x1: "184.71%",
    x2: "713.697%",
    y1: "-260.235%",
    y2: "-1526.896%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c60urwnd3k",
    x1: "210.111%",
    x2: "680.953%",
    y1: "-319.962%",
    y2: "-1440.928%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ggxx9605cl",
    x1: "97.13%",
    x2: "796.946%",
    y1: "-59.546%",
    y2: "-1735.241%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zq065uznvm",
    x1: "138.785%",
    x2: "778.899%",
    y1: "-156.834%",
    y2: "-1689.011%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2ay1kcvazn",
    x1: "177.685%",
    x2: "752.939%",
    y1: "-244.121%",
    y2: "-1621.573%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d3kau6l03o",
    x1: "212.443%",
    x2: "734.709%",
    y1: "-325.153%",
    y2: "-1575.684%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "24w7nfzs9p",
    x1: "240.001%",
    x2: "704.82%",
    y1: "-390.371%",
    y2: "-1499.243%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5t9kay5knq",
    x1: "47.859%",
    x2: "844.068%",
    y1: "50.644%",
    y2: "-1884.86%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oqeqq2ra9r",
    x1: "98.969%",
    x2: "814.046%",
    y1: "-62.251%",
    y2: "-1774.491%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crky5mevms",
    x1: "141.577%",
    x2: "787.023%",
    y1: "-162.256%",
    y2: "-1700.293%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5z6r4c8rht",
    x1: "180.683%",
    x2: "754.349%",
    y1: "-251.284%",
    y2: "-1624.923%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6x1cocn4tu",
    x1: "215.689%",
    x2: "736.874%",
    y1: "-333.717%",
    y2: "-1576.875%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b42uo8np2v",
    x1: "249.069%",
    x2: "718.054%",
    y1: "-408.855%",
    y2: "-1531.855%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dbhf3mcvew",
    x1: "33.936%",
    x2: "835.361%",
    y1: "88.663%",
    y2: "-1866.521%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ls135c03sx",
    x1: "79.91%",
    x2: "805.744%",
    y1: "-23.208%",
    y2: "-1780.882%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vamefq0eey",
    x1: "121.929%",
    x2: "768.662%",
    y1: "-123.981%",
    y2: "-1705.934%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xly2jor03z",
    x1: "160.09%",
    x2: "734.352%",
    y1: "-205.626%",
    y2: "-1580.718%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zdmqv0sr1A",
    x1: "192.968%",
    x2: "708.292%",
    y1: "-282.644%",
    y2: "-1516.59%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i89cznnt3B",
    x1: "223.734%",
    x2: "690.85%",
    y1: "-359.641%",
    y2: "-1487.157%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xx32eiy03C",
    x1: "4.762%",
    x2: "793.583%",
    y1: "153.077%",
    y2: "-1706.588%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "imv9m9abdD",
    x1: "46.166%",
    x2: "783.292%",
    y1: "58.6%",
    y2: "-1706.444%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xkq95lcziE",
    x1: "83.883%",
    x2: "720.513%",
    y1: "-31.44%",
    y2: "-1564.592%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp8v2wvyaF",
    x1: "118.67%",
    x2: "685.884%",
    y1: "-106.181%",
    y2: "-1457.647%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "197x7nngrG",
    x1: "148.448%",
    x2: "665.522%",
    y1: "-173.975%",
    y2: "-1383.712%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w6rhbgfp9H",
    x1: "177.743%",
    x2: "642.463%",
    y1: "-241.573%",
    y2: "-1349.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t1p4jx5pzI",
    x1: "-33.241%",
    x2: "764.602%",
    y1: "247.78%",
    y2: "-1683.849%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gowufyeyaJ",
    x1: "-.338%",
    x2: "709.275%",
    y1: "163.749%",
    y2: "-1521.571%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gvzenncevK",
    x1: "32.067%",
    x2: "663.851%",
    y1: "89.97%",
    y2: "-1424.525%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i6aripf6dL",
    x1: "60.983%",
    x2: "629.166%",
    y1: "27.981%",
    y2: "-1324.092%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3scvan1pzM",
    x1: "86.184%",
    x2: "611.18%",
    y1: "-32.666%",
    y2: "-1289.763%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ekrbnhg8iN",
    x1: "107.938%",
    x2: "571.713%",
    y1: "-83.716%",
    y2: "-1194.18%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o62dyuxhkO",
    x1: "-79.114%",
    x2: "718.885%",
    y1: "351.547%",
    y2: "-1559.269%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k1oud7wx8P",
    x1: "-49.41%",
    x2: "645.437%",
    y1: "281.969%",
    y2: "-1369.79%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ym2ml2qnkQ",
    x1: "-30.253%",
    x2: "609.901%",
    y1: "238.244%",
    y2: "-1294.586%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0u0rkwqs4R",
    x1: "-9.393%",
    x2: "562.974%",
    y1: "187.736%",
    y2: "-1175.401%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sn4cgndyzS",
    x1: "7.767%",
    x2: "527.672%",
    y1: "145.991%",
    y2: "-1093.305%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo1q49hncT",
    x1: "25.113%",
    x2: "489.833%",
    y1: "108.463%",
    y2: "-1004.309%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pt8y58qazU",
    x1: "-128.093%",
    x2: "668.292%",
    y1: "461.037%",
    y2: "-1445.882%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p4udi5p1bV",
    x1: "-113.322%",
    x2: "605.965%",
    y1: "428.688%",
    y2: "-1303.24%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e6xsbvftaW",
    x1: "-98.756%",
    x2: "546.723%",
    y1: "390.602%",
    y2: "-1135.533%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av80zdu82X",
    x1: "-86.794%",
    x2: "495.715%",
    y1: "371.579%",
    y2: "-1044.928%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jc5gb541hY",
    x1: "-74.425%",
    x2: "446.847%",
    y1: "332.369%",
    y2: "-886.952%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q45oyc6xfZ",
    x1: "-64.404%",
    x2: "404.506%",
    y1: "316.489%",
    y2: "-806.313%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fj3sqfbsfaa",
    x1: "-172.624%",
    x2: "624.897%",
    y1: "563.746%",
    y2: "-1345.856%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pge7eapokab",
    x1: "-168.304%",
    x2: "549.463%",
    y1: "545.728%",
    y2: "-1153.739%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n8ka4kpzvac",
    x1: "-161.521%",
    x2: "479.688%",
    y1: "535.129%",
    y2: "-983.037%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kbwiqss54ad",
    x1: "-151.432%",
    x2: "412.089%",
    y1: "510.554%",
    y2: "-813.534%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac4e1djbdae",
    x1: "-155.082%",
    x2: "366.023%",
    y1: "529.359%",
    y2: "-729.67%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jh3u3bxg0af",
    x1: "-205.825%",
    x2: "582.998%",
    y1: "642.882%",
    y2: "-1245.962%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l0jnxku3nag",
    x1: "-216.114%",
    x2: "505.674%",
    y1: "650.824%",
    y2: "-1041.386%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zvz0vzpegah",
    x1: "-217.197%",
    x2: "427.529%",
    y1: "679.626%",
    y2: "-883.623%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdo8vkwh3ai",
    x1: "-214.264%",
    x2: "352.849%",
    y1: "662.167%",
    y2: "-689.068%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dac6sfnm0aj",
    x1: "-244.276%",
    x2: "465.408%",
    y1: "733.841%",
    y2: "-965.449%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qmnqn1papak",
    x1: "-252.092%",
    x2: "379.661%",
    y1: "752.346%",
    y2: "-760.381%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9142r61zaal",
    x1: "-258.642%",
    x2: "441.171%",
    y1: "765.201%",
    y2: "-910.491%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i487vmydram",
    x1: "-278.041%",
    x2: "362.169%",
    y1: "810.739%",
    y2: "-721.674%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alg32wpnaan",
    x1: "-279.958%",
    x2: "358.974%",
    y1: "795.715%",
    y2: "-698.984%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sz6l12lqka"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#sz6l12lqka)",
    transform: "translate(-15 -9) translate(15 9)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ipc6mias7b)",
    d: "M18.957 15.854c.343-.168.729-.042.9.253.172.336.043.715-.257.883-.343.168-.73.042-.9-.252-.215-.295-.087-.715.257-.884z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#mnyh3aekkc)",
    d: "M20.8 19.177c.43-.21.902-.085 1.159.336.214.42.086.883-.343 1.135-.386.21-.901.084-1.159-.336-.214-.42-.085-.925.344-1.135z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#5p1lq97u1d)",
    d: "M21.874 21.153c.472-.252 1.03-.084 1.244.379.258.462.086 1.009-.386 1.22-.472.252-1.03.083-1.244-.38-.257-.462-.086-1.008.386-1.219z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#utfejok9me)",
    d: "M23.074 23.298c.515-.253 1.116-.084 1.416.42.258.505.086 1.093-.429 1.388-.515.252-1.115.084-1.416-.42-.257-.505-.085-1.136.43-1.388z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#krj7kdqc5f)",
    d: "M17.154 16.275c.386-.084.73.168.772.547.086.378-.171.714-.557.756-.387.085-.73-.168-.773-.546-.043-.337.215-.715.558-.757z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x3qnbtuiag)",
    d: "M17.498 18.041c.43-.084.815.21.901.59.086.42-.214.798-.6.882-.43.084-.816-.21-.901-.589-.086-.42.214-.84.6-.883z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dx8booluuh)",
    d: "M20.03 17.326c.428-.084.814.21.9.589.086.42-.214.799-.6.883-.43.084-.816-.21-.901-.589-.086-.42.171-.799.6-.883z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#csg60kroei)",
    d: "M17.884 19.976c.471-.084.9.21.986.673.086.462-.214.883-.686.967-.472.084-.901-.21-.987-.673-.086-.462.215-.883.687-.967z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j53wtu0exj)",
    d: "M18.27 22.161c.514-.084.986.253 1.072.715.086.505-.258.967-.73 1.052-.514.084-.986-.253-1.072-.715-.086-.463.257-.968.73-1.052z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c60urwnd3k)",
    d: "M18.742 24.6c.558-.084 1.116.253 1.202.8.085.546-.258 1.093-.815 1.177-.558.084-1.116-.253-1.202-.8-.128-.546.258-1.093.816-1.177z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ggxx9605cl)",
    d: "M15.352 16.107c.387.042.644.378.601.757-.043.378-.386.63-.772.588-.386-.042-.644-.378-.6-.757.085-.378.385-.63.771-.588z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zq065uznvm)",
    d: "M15.139 17.873c.429.042.686.42.643.84-.043.421-.429.674-.858.632-.429-.043-.686-.421-.643-.842.043-.378.429-.672.858-.63z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2ay1kcvazn)",
    d: "M14.838 19.849c.472.042.772.462.73.925-.043.462-.472.757-.944.715-.472-.042-.772-.463-.73-.926.086-.462.515-.756.944-.714z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d3kau6l03o)",
    d: "M14.538 22.037c.515.084.858.504.815 1.009-.086.504-.558.84-1.03.799-.514-.084-.858-.505-.815-1.01.086-.504.558-.84 1.03-.798z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#24w7nfzs9p)",
    d: "M14.237 24.475c.558.084.987.589.9 1.136-.085.546-.6.967-1.157.883-.558-.084-.987-.589-.901-1.136.043-.546.6-.925 1.158-.883z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#5t9kay5knq)",
    d: "M14.41 13.962c.3.126.428.505.3.8-.13.294-.515.42-.816.294-.3-.126-.429-.505-.3-.8.129-.294.515-.462.815-.294z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#oqeqq2ra9r)",
    d: "M13.68 15.433c.343.168.472.547.3.883-.171.337-.557.463-.9.295-.344-.169-.472-.547-.3-.884.17-.336.557-.462.9-.294z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#crky5mevms)",
    d: "M12.908 17.032c.386.168.515.63.343.967-.171.378-.643.546-.986.336-.386-.168-.558-.63-.344-.967.13-.336.601-.505.987-.336z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#5z6r4c8rht)",
    d: "M12.006 18.84c.43.21.6.672.386 1.093-.214.42-.686.588-1.115.378-.43-.21-.6-.673-.386-1.093.214-.42.73-.589 1.115-.379z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#6x1cocn4tu)",
    d: "M11.063 20.817c.472.21.643.757.429 1.22-.215.462-.772.63-1.244.42-.472-.21-.644-.757-.43-1.22.215-.42.773-.63 1.245-.42z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b42uo8np2v)",
    d: "M9.947 23.045c.514.252.729.84.471 1.345-.257.505-.858.715-1.372.463-.515-.252-.73-.841-.472-1.346.257-.504.858-.715 1.373-.462z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dbhf3mcvew)",
    d: "M13.422 13.08c.257.21.257.588.043.84-.215.253-.6.253-.858.043-.257-.21-.257-.59 0-.841.214-.253.6-.295.815-.042z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ls135c03sx)",
    d: "M12.307 14.256c.258.252.3.673.043.925-.257.253-.686.295-.943.042-.258-.252-.3-.673-.043-.925.257-.294.686-.294.943-.042z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vamefq0eey)",
    d: "M11.063 15.56c.3.294.3.757.042 1.051-.3.295-.772.295-1.072.042-.3-.294-.3-.757-.043-1.051.3-.337.772-.337 1.073-.042z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#xly2jor03z)",
    d: "M9.648 16.99c.343.295.343.841.043 1.178-.3.336-.858.336-1.202.042-.343-.295-.343-.841-.043-1.178.344-.336.858-.336 1.202-.042z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zdmqv0sr1A)",
    d: "M8.102 18.587c.386.337.386.925.043 1.304-.343.378-.944.378-1.33.042-.386-.336-.386-.925-.043-1.304.343-.378.944-.378 1.33-.042z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i89cznnt3B)",
    d: "M6.386 20.395c.429.379.429 1.01.043 1.43-.386.42-1.03.42-1.459.042-.429-.378-.429-1.01-.043-1.43.386-.42 1.03-.462 1.459-.042z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#xx32eiy03C)",
    d: "M12.822 11.944c.171.294.043.672-.258.799-.3.168-.686.042-.815-.253-.171-.294-.043-.673.258-.799.3-.126.643-.042.815.253z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#imv9m9abdD)",
    d: "M11.363 12.7c.172.337.043.715-.257.884-.343.168-.73.042-.901-.253-.172-.336-.043-.715.257-.883.3-.168.73-.042.901.252z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#xkq95lcziE)",
    d: "M9.775 13.584c.214.379.043.8-.3 1.01-.386.21-.815.041-1.03-.295-.214-.378-.043-.799.3-1.01.344-.21.815-.083 1.03.295z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gp8v2wvyaF)",
    d: "M7.974 14.508c.215.379.086.883-.343 1.136-.386.21-.9.084-1.158-.337-.215-.378-.086-.883.343-1.135.429-.21.944-.042 1.158.336z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#197x7nngrG)",
    d: "M6 15.56c.257.463.086 1.01-.386 1.22-.472.252-1.03.084-1.244-.379-.258-.378-.086-.967.343-1.177.472-.253 1.03-.084 1.287.336z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w6rhbgfp9H)",
    d: "M3.77 16.738c.258.504.086 1.093-.429 1.387-.514.253-1.115.085-1.415-.42-.258-.505-.086-1.093.429-1.388.515-.252 1.158-.042 1.415.42z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t1p4jx5pzI)",
    d: "M12.565 10.682c.042.336-.172.63-.472.715-.344.042-.644-.168-.73-.463-.043-.336.172-.63.472-.715.386-.084.687.127.73.463z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gowufyeyaJ)",
    d: "M10.976 10.975c.086.379-.171.715-.557.757-.386.084-.73-.168-.773-.546-.085-.379.172-.715.558-.757.343-.042.687.168.772.546z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gvzenncevK)",
    d: "M9.175 11.313c.086.42-.215.8-.6.883-.43.084-.816-.21-.902-.588-.085-.42.215-.8.6-.884.43-.084.816.169.902.59z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i6aripf6dL)",
    d: "M7.158 11.649c.086.462-.214.883-.686.967-.472.084-.901-.21-.987-.673-.086-.462.214-.883.686-.967.472-.042.901.252.987.673z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#3scvan1pzM)",
    d: "M4.927 12.07c.086.504-.257.967-.729 1.05-.515.085-.987-.252-1.072-.714-.129-.505.214-.967.729-1.051.515-.127.987.21 1.072.715z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ekrbnhg8iN)",
    d: "M2.483 12.533c.086.547-.258 1.093-.815 1.177-.6.084-1.116-.252-1.244-.84-.086-.547.257-1.094.815-1.178.6-.084 1.115.252 1.244.84z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o62dyuxhkO)",
    d: "M12.735 9.42c-.043.337-.343.547-.686.505-.344-.042-.558-.336-.515-.673.043-.336.343-.546.686-.504.343.042.558.336.515.673z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k1oud7wx8P)",
    d: "M11.105 9.21c-.043.379-.386.631-.772.59-.386-.043-.644-.38-.6-.758.042-.378.385-.63.771-.588.387.042.687.378.601.757z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ym2ml2qnkQ)",
    d: "M9.304 8.958c-.043.421-.43.673-.858.631-.43-.042-.687-.42-.644-.84.043-.421.43-.674.858-.632.43.085.687.463.644.841z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#0u0rkwqs4R)",
    d: "M7.288 8.706c-.043.462-.472.757-.944.715-.471-.042-.772-.463-.729-.925.043-.463.472-.757.944-.715.472.042.815.462.73.925z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sn4cgndyzS)",
    d: "M5.056 8.41c-.086.505-.515.841-1.03.8-.514-.085-.858-.505-.815-1.01.086-.504.558-.84 1.03-.799.515.042.9.505.815 1.01z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bo1q49hncT)",
    d: "M2.568 8.074c-.085.547-.6.967-1.158.883-.558-.042-.987-.589-.9-1.135.085-.547.6-.967 1.157-.883.558.084.987.588.901 1.135z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pt8y58qazU)",
    d: "M13.336 8.242c-.129.294-.515.42-.815.294-.3-.126-.43-.504-.3-.799.128-.294.514-.42.814-.294.3.168.43.505.3.799z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p4udi5p1bV)",
    d: "M11.835 7.57c-.171.337-.557.463-.9.295-.344-.168-.472-.547-.3-.883.17-.337.557-.463.9-.295.3.127.472.547.3.884z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e6xsbvftaW)",
    d: "M10.162 6.77c-.172.379-.643.505-.987.337-.386-.169-.514-.631-.343-.968.172-.378.644-.504.987-.336.386.168.558.63.343.967z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#av80zdu82X)",
    d: "M8.36 5.93c-.214.42-.686.589-1.115.378-.43-.21-.6-.672-.386-1.093.214-.42.686-.589 1.115-.378.386.21.558.672.386 1.093z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#jc5gb541hY)",
    d: "M6.301 4.963c-.214.463-.772.631-1.244.42-.472-.21-.643-.756-.429-1.177.215-.462.772-.63 1.244-.42.472.168.644.715.43 1.177z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q45oyc6xfZ)",
    d: "M4.028 3.911c-.258.505-.858.715-1.373.463-.515-.21-.73-.841-.472-1.346.257-.504.858-.715 1.373-.462.515.252.73.84.472 1.345z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fj3sqfbsfaa)",
    d: "M14.237 7.317c-.214.252-.6.252-.858.042-.257-.21-.257-.589-.043-.841.215-.252.6-.252.858-.042s.258.589.043.841z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pge7eapokab)",
    d: "M13.036 6.225c-.258.252-.687.294-.944.042-.258-.253-.3-.673-.043-.925.257-.253.686-.295.944-.042.3.21.3.63.043.925z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n8ka4kpzvac)",
    d: "M11.706 4.963c-.3.295-.772.295-1.072.042-.3-.294-.3-.757-.043-1.051.3-.294.772-.294 1.072-.042.3.294.344.757.043 1.051z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kbwiqss54ad)",
    d: "M10.205 3.616c-.3.337-.858.337-1.2.042-.344-.294-.344-.84-.044-1.177.3-.336.858-.336 1.201-.042.386.336.386.84.043 1.177z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac4e1djbdae)",
    d: "M8.575 2.06c-.343.379-.943.421-1.287.043-.386-.337-.386-.926-.043-1.304.344-.336.944-.379 1.33 0 .344.336.386.925 0 1.262z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#jh3u3bxg0af)",
    d: "M15.353 6.73c-.3.168-.686.042-.815-.253-.171-.294-.043-.672.258-.799.3-.168.686-.042.815.253.171.252.043.63-.258.799z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l0jnxku3nag)",
    d: "M14.58 5.3c-.343.168-.73.041-.9-.253-.172-.336-.044-.715.257-.883.343-.168.729-.042.9.252.215.295.086.715-.257.883z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zvz0vzpegah)",
    d: "M13.722 3.702c-.386.21-.815.042-1.03-.295-.214-.378-.043-.799.3-1.009.387-.21.816-.042 1.03.295.172.378.043.84-.3 1.009z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bdo8vkwh3ai)",
    d: "M12.736 1.977c-.386.21-.901.084-1.159-.336-.214-.379-.085-.883.344-1.136.429-.21.943-.042 1.158.337.214.42.086.925-.343 1.135z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dac6sfnm0aj)",
    d: "M16.34 4.88c-.387.083-.73-.169-.773-.547-.086-.379.172-.715.558-.757.386-.084.729.168.772.546.086.337-.172.715-.558.757z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qmnqn1papak)",
    d: "M16.04 3.113c-.43.084-.816-.21-.902-.589-.086-.42.215-.799.6-.883.43-.084.816.21.902.589.086.42-.215.84-.6.883z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9142r61zaal)",
    d: "M18.183 5.047c-.386-.042-.643-.379-.6-.757.043-.379.386-.631.772-.59.386.043.643.38.6.758-.085.378-.428.63-.772.589z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i487vmydram)",
    d: "M18.398 3.28c-.429-.041-.686-.42-.643-.84.043-.42.429-.673.858-.63.429.041.686.42.643.84-.042.379-.429.673-.858.63z",
    transform: "translate(2.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#alg32wpnaan)",
    d: "M20.63 4.122c-.387-.168-.516-.63-.344-.967.172-.378.644-.505.987-.336.386.126.558.588.386.967-.215.378-.644.504-1.03.336z",
    transform: "translate(2.5 1.5)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.5f946375.svg";
export { ForwardRef as ReactComponent };